const shoppingCart = `
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 224.999 200">
    <path id="Path_2" data-name="Path 2" d="M206.3-57.3l18.466-81.25A9.375,9.375,0,0,0,215.621-150H62.19l-3.58-17.5a9.375,9.375,0,0,0-9.185-7.5H9.375A9.375,9.375,0,0,0,0-165.625v6.25A9.375,9.375,0,0,0,9.375-150h27.3L64.113-15.846A21.877,21.877,0,1,0,90.3-12.5H172.2a21.869,21.869,0,1,0,24.843-4.065l2.155-9.483A9.375,9.375,0,0,0,190.052-37.5H85.2L82.645-50H197.155A9.375,9.375,0,0,0,206.3-57.3Z" transform="translate(0 175)" fill="#fff"/>
  </svg>
`

export default shoppingCart
